"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.4999 8.74998L9.16656 10.4166L12.9166 6.66665M16.6665 17.4999V6.49999C16.6665 5.09986 16.6665 4.3998 16.3941 3.86502C16.1544 3.39462 15.7719 3.01217 15.3015 2.77248C14.7667 2.5 14.0667 2.5 12.6666 2.5H7.33324C5.93311 2.5 5.23305 2.5 4.69827 2.77248C4.22787 3.01217 3.84542 3.39462 3.60573 3.86502C3.33325 4.3998 3.33325 5.09986 3.33325 6.49999V17.4999L5.62491 15.8333L7.70824 17.4999L9.99989 15.8333L12.2916 17.4999L14.3749 15.8333L16.6665 17.4999Z",
    stroke: fill,
    strokeWidth: "1.66666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;